import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllCoursesUserResponse } from 'domain/models';

interface ICoursesState {
  coursesUser: GetAllCoursesUserResponse[];
  loadingCoursesUser: boolean;
}

interface IPayloadCoursesUser
  extends PayloadAction<GetAllCoursesUserResponse[]> {}

const initialState: ICoursesState = {
  coursesUser: [],
  loadingCoursesUser: false,
};

export const CoursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    loadCoursesUser: (state, action: IPayloadCoursesUser) => {
      state.coursesUser = action.payload;
    },
    setLoadingCoursesUser: (state, action: PayloadAction<boolean>) => {
      state.loadingCoursesUser = action.payload;
    },
  },
});

export const { loadCoursesUser, setLoadingCoursesUser } = CoursesSlice.actions;

export default CoursesSlice.reducer;
